<template>
    <div class="card_open_container">
        <!-- Desktop -->
        <transition name="fade" appear>
            <template  v-if="!card.fields.image">
                <div class="card_open no_image" v-bind:class="card.fields.cardType | lower_case">
                    <svg v-on:click="navigate('desktop')" class="card_close" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><title>Group 4</title><g stroke="#FFF" stroke-width="3" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M2.46 1.64l24.917 24.915M27.377 1.64L2.46 26.554"/></g></svg>
                    <p class="card_number">{{ card.fields.cardNumber | card_number }}</p>
                    <div class="card_content">
                        <p class="card_title" >{{ card.fields.cardTitle }}</p>
                        <p v-if="card.fields.sponsored" class="card_sponsored">presented by toyota c-hr</p>
                        <p class="card_description">{{ card.fields.cardFullDescription }}</p>
                        <div class="card_buttons">
                            <div class="bttn_default bttn_share">
                                share
                                <div class="social_icons">
                                    <i class="fa fa-facebook" v-on:click="facebook" aria-hidden="true"></i>
                                    <a class="mail_link" v-on:click="email" v-bind:href="'mailto:?subject=100%20Days%20of%20Summer&body=http://refinery29.com/things-to-do-summer-2017/#/' + card.fields.cardNumber"><i class="fa fa-envelope-o" aria-hidden="true"></i></a>
                                    <div class="link_icon" v-on:click="clipboard_click" v-bind:data-clipboard-text="'http://refinery29.com/things-to-do-summer-2017/#/' + card.fields.cardNumber">
                                        <img src="../assets/img/link.svg" />
                                    </div>
                                </div>
                            </div>
                            <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-if="card.fields.cardType == 'Do'">{{ card.fields.cardType }}</a>
                            <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-else-if="card.fields.cardType == 'Listen'">{{ card.fields.cardType }}</a>
                            <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-else-if="card.fields.cardType == 'Make'">{{ card.fields.cardType }}</a>
                            <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-else-if="card.fields.cardType == 'Buy'">{{ card.fields.cardType }}</a>
                            <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-else>watch</a>
                        </div>
                    </div>
                    <img v-if="card.fields.cardType == 'Do'" class="card_icon" src="../assets/img/do.svg" />
                    <img v-else-if="card.fields.cardType == 'Listen'" class="card_icon" src="../assets/img/listen.svg" />
                    <img v-else-if="card.fields.cardType == 'Make'" class="card_icon" src="../assets/img/make.svg" />
                    <img v-else-if="card.fields.cardType == 'Buy'" class="card_icon" src="../assets/img/buy.svg" />
                    <img v-else class="card_icon" src="../assets/img/watch.svg" />
                </div>
            </template>
            <template  v-if="card && card.fields.image">
                <div class="card_open has_image" v-bind:class="card.fields.cardType.toLowerCase()">
                    <div class="card_open_image" v-bind:style="{ 'background-image': 'url(' + card.fields.image + ')' }"></div>
                    <p v-if="card.fields.disclaimer" class="card_sponsored disclaimer">{{ card.fields.disclaimer }}</p>
                    <div class="card_open_content">
                        <svg v-on:click="navigate('desktop')" class="card_close" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><title>Group 4</title><g stroke="#FFF" stroke-width="3" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M2.46 1.64l24.917 24.915M27.377 1.64L2.46 26.554"/></g></svg>
                        <p class="card_number">{{ card.fields.cardNumber | card_number }}</p>
                        <div class="card_content">
                            <p class="card_title" >{{ card.fields.cardTitle }}</p>
                            <p v-if="card.fields.sponsored" class="card_sponsored">presented by toyota c-hr</p>
                            <p class="card_description">{{ card.fields.cardFullDescription }}</p>
                            <div class="card_buttons">
								<div class="bttn_default bttn_share">
	                                share
	                                <div class="social_icons">
	                                    <i class="fa fa-facebook" v-on:click="facebook" aria-hidden="true"></i>
	                                    <a class="mail_link" v-on:click="email" v-bind:href="'mailto:?subject=100%20Days%20of%20Summer&body=http://refinery29.com/things-to-do-summer-2017/#/' + card.fields.cardNumber"><i class="fa fa-envelope-o" aria-hidden="true"></i></a>
	                                    <div class="link_icon" v-on:click="clipboard_click" v-bind:data-clipboard-text="'http://refinery29.com/things-to-do-summer-2017/#/' + card.fields.cardNumber">
	                                        <img src="../assets/img/link.svg" />
	                                    </div>
	                                </div>
	                            </div>
                                <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-if="card.fields.cardType == 'Do'">{{ card.fields.cardType }}</a>
                                <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-else-if="card.fields.cardType == 'Listen'">{{ card.fields.cardType }}</a>
                                <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-else-if="card.fields.cardType == 'Make'">{{ card.fields.cardType }}</a>
                                <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-else-if="card.fields.cardType == 'Buy'">{{ card.fields.cardType }}</a>
                                <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-else>watch</a>
                            </div>
                        </div>
                        <img v-if="card.fields.cardType == 'Do'" class="card_icon" src="../assets/img/do.svg" />
                        <img v-else-if="card.fields.cardType == 'Listen'" class="card_icon" src="../assets/img/listen.svg" />
                        <img v-else-if="card.fields.cardType == 'Make'" class="card_icon" src="../assets/img/make.svg" />
                        <img v-else-if="card.fields.cardType == 'Buy'" class="card_icon" src="../assets/img/buy.svg" />
                        <img v-else="card.fields.cardType == 'Watch'" class="card_icon" src="../assets/img/watch.svg" />
                    </div>
                </div>
            </template>
        </transition>
        <!-- Mobile -->
        <transition appear v-on:appear="mobile_animation_enter">
            <template>
                <div id="card_mobile" v-bind:class="[card.fields.cardType.toLowerCase(), { facebook: facebook_browser }]">
                    <img v-on:click="navigate('mobile')" class="card_close" src="../assets/img/close.svg" />
                    <p class="card_title" >{{ card.fields.cardTitle }}</p>
                    <p v-if="card.fields.sponsored" class="mobile_card_sponsored">presented by toyota c-hr</p>
                    <div v-if="card.fields.image" class="card_mobile_image" v-bind:style="{ 'background-image': 'url(' + card.fields.image + ')' }"></div>
                    <p v-if="card.fields.disclaimer" class="mobile_card_sponsored disclaimer">{{ card.fields.disclaimer }}</p>
                    <p class="card_mobile_description">{{ card.fields.cardFullDescription }}</p>
                    <div class="card_buttons">
                        <div class="bttn_default bttn_share" v-on:click="mobile_share_button" v-bind:class="{ active: mobile_share_active }">
                            share
                            <div class="social_icons">
                                <i class="fa fa-facebook" v-on:click="facebook" aria-hidden="true"></i>
                                <a class="mail_link" v-on:click="email" v-bind:href="'mailto:?subject=100%20Days%20of%20Summer&body=http://refinery29.com/things-to-do-summer-2017/#/' + card.fields.cardNumber"><i class="fa fa-envelope-o" aria-hidden="true"></i></a>
                                <div class="link_icon" v-on:click="clipboard_click" v-bind:data-clipboard-text="'http://refinery29.com/things-to-do-summer-2017/#/' + card.fields.cardNumber">
                                    <img src="../assets/img/link.svg" />
                                </div>
                            </div>
                        </div>
                        <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-if="card.fields.cardType == 'Do'">{{ card.fields.cardType }}</a>
                        <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-else-if="card.fields.cardType == 'Listen'">{{ card.fields.cardType }}</a>
                        <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-else-if="card.fields.cardType == 'Make'">{{ card.fields.cardType }}</a>
                        <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-else-if="card.fields.cardType == 'Buy'">{{ card.fields.cardType }}</a>
                        <a class="bttn_default" v-bind:href="card.fields.clickOutUrl" v-on:click="card_link_ga" target="_blank" v-else>watch</a>
                    </div>
                    <img v-if="card.fields.cardType == 'Do'" class="card_icon" src="../assets/img/do.svg" />
                    <img v-else-if="card.fields.cardType == 'Listen'" class="card_icon" src="../assets/img/listen.svg" />
                    <img v-else-if="card.fields.cardType == 'Make'" class="card_icon" src="../assets/img/make.svg" />
                    <img v-else-if="card.fields.cardType == 'Buy'" class="card_icon" src="../assets/img/buy.svg" />
                    <img v-else="card.fields.cardType == 'Watch'" class="card_icon" src="../assets/img/watch.svg" />
				</div>
            </template>
        </transition>
        <div id="clipboard_message" v-show="clipboard_message">
            <p>Link has been copied to clipboard</p>
        </div>
    </div>
</template>

<script>
	import * as clipboard from 'clipboard';
	import * as contentful from 'contentful';
	import Router from 'vue-router';
	import anime from 'animejs';

    export default {
        name: 'card-open',
        data: function() {
            return {
                card: {
                    fields: {
                        cardType: ""
                    }
                },
                client: null,
				mobile_share_active: false,
                clipboard_message: false,
                facebook_browser: false
            }
        },
        methods: {
            close_modal: function() {
                this.$emit('cardopen', false);
            },
            facebook: function() {
                let url = 'http://refinery29.com/things-to-do-summer-2017/%23/' + this.card.fields.cardNumber;
                window.open('https://www.facebook.com/dialog/share?app_id=1592779707413374&mobile_iframe=true&href=' + url, '_blank', 'left=100,top=100,width=500,height=500');
                ga('send', 'event', 'Bespoke 100 Days of Summer', 'facebook', this.card.fields.cardNumber);
				console.log('https://www.facebook.com/dialog/share?app_id=1592779707413374&mobile_iframe=true&href=' + url);
            },
            email: function() {
                ga('send', 'event', 'Bespoke 100 Days of Summer', 'email', this.card.fields.cardNumber);
            },
            navigate: function(val) {
                this.$emit('cardopen', false);

				if (val == 'desktop') {
					anime({
						targets: '.card_open',
						opacity: 0,
						duration: 500,
						easing: 'linear',
						complete: () => {
							this.$router.push('/');
						}
					});

				} else if (val == 'mobile') {
					anime({
						targets: '#card_mobile',
						opacity: 0,
						scale: [1, 0.5],
						easing: 'easeInQuad',
						duration: 300,
						complete: () => {
	                        this.$router.push('/');
	                    }
					});
				}

            },
            card_link_ga: function() {
                ga('send', 'event', 'Bespoke 100 Days of Summer', 'cta clicked', this.card.fields.cardNumber);
            },
			mobile_animation_enter: function() {
				anime({
					targets: '#card_mobile',
					opacity: 1,
					scale: [0.5, 1],
					easing: 'easeInQuad',
					duration: 300
				});
			},
			clipboard_click: function() {
				anime({
					targets: '.link_icon',
					scale: [
						{ value: 0.75, easing: 'easeInQuad', duration: 200 },
						{ value: 1, duration: 500 }
					]
				});

                this.clipboard_message = true;

                anime({
                    targets: '#clipboard_message',
                    opacity: [
                        { value: 1, duration: 300, easing: 'linear' },
                        { value: 0, duration: 300, delay: 1000, easing: 'linear' }
                    ],
                    complete: ()=> {
                        this.clipboard_message = false;
                    }
                });

                ga('send', 'event', 'Bespoke 100 Days of Summer', 'clipboard', this.card.fields.cardNumber);
			},
			mobile_share_button: function() {
				this.mobile_share_active = true;
			}
        },
        filters: {
            card_number: function(number) {
                if (number < 10) {
                    return "0" + number;
                } else {
                    return number;
                }
            },
            lower_case: function(string) {
                if (string) {
                    return string.toLowerCase();
                }
            }
        },
		mounted: function() {
			new clipboard('.link_icon');
			this.$emit('mobile');

            var ua = navigator.userAgent || navigator.vendor || window.opera;
            this.facebook_browser = (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
		},
        beforeRouteEnter: function(to, from, next) {
            let client = contentful.createClient({
                space: 'r1t1gplw57al',
                accessToken: 'f2c158bbed860f1ac464cb5125c20db8749dc863c701adcec51b442529c97794'
            });

            client.getEntries({
                content_type: 'card',
                'fields.cardNumber': to.params.card_number
            }).then((response) => {

                next(vm => {
                    vm.card = response.items[0];
                    vm.$emit('cardopen', true);
                    vm.$emit('updateHead');
                    console.log(vm.card);
                    ga('send', 'event', 'Bespoke 100 Days of Summer', 'card selected', vm.card.fields.cardNumber);
                });
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/variables';
    @import '../assets/scss/utilities';

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .card_open {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        text-align: center;
        box-shadow: 0px 0px 10px 2px rgba(0,0,0,0.2);

		.bttn_share:hover {
            background-color: white;
			color: white !important;
            .social_icons {
				top: 0;
                opacity: 1;
            }
	    }

        &.no_image {
            width: 60vw;
            height: 60vw;
            max-width: 600px;
            max-height: 600px;
        }

        &.has_image {
            display: flex;
            width: 90vw;
            height: 45vw;
            max-width: 1200px;
            max-height: 600px;

            .card_sponsored.disclaimer {
                max-width: 400px;
            }
        }

        p {
            color: white;
        }

        .social_icons {
            .fa:hover, .link_icon:hover {
                opacity: 0.5;
            }
        }

        &.do {
            background-color: $red;

            .social_icons {

                .fa, .link_icon {
                    background-color: $red;
                }
            }

			.bttn_default:hover {
				background-color: white;
				color: $red;
			}

            .card_close:hover path {
                stroke: $red;
            }
        }

        &.listen {
            background-color: $orange;

            .social_icons {

                .fa, .link_icon {
                    background-color: $orange;
                }
            }

			.bttn_default:hover {
				background-color: white;
				color: $orange;
			}

            .card_close:hover path {
                stroke: $orange;
            }
        }
        &.make {
            background-color: $yellow;

            .social_icons {

                .fa, .link_icon {
                    background-color: $yellow;
                }
            }

			.bttn_default:hover {
				background-color: white;
				color: $yellow;
			}

            .card_close:hover path {
                stroke: $yellow;
            }
        }
        &.buy {
            background-color: $pink;

            .social_icons {

                .fa, .link_icon {
                    background-color: $pink;
                }
            }

			.bttn_default:hover {
				background-color: white;
				color: $pink;
			}

            .card_close:hover path {
                stroke: $pink;
            }
        }
        &.watch {
            background-color: $peach;

            .social_icons {

                .fa, .link_icon {
                    background-color: $peach;
                }
            }

			.bttn_default:hover {
				background-color: white;
				color: $peach;
			}

            .card_close:hover path {
                stroke: $peach;
            }
        }

        .card_title {
            margin: 0;
        }

        .card_content {
            width: 90%;
            left: 5%;
        }

        .card_number {
            top: 5%;
        }

        .card_icon {
            bottom: 5%;
        }

        .card_sponsored {
            margin-top: 20px;
        }
    }

    .card_open_image {
        width: 50%;
        @extend .standard_bg;
    }

    .card_open_content {
        width: 50%;
        position: relative;
    }

    .card_description {
        margin-top: 45px;
        margin-bottom: 25px;
    }

    .card_buttons {
        display: flex;
        width: 350px;
        margin: auto;
        justify-content: space-between;
    }

    .card_close {
        display: block;
        position: absolute;
        top: 5%;
        right: 5%;
        cursor: pointer;
        z-index: 1;
        padding: 7px;
        border-radius: 50%;
        transition: background-color 0.5s;

        &:hover {
            background-color: white;
        }

        path {
            transition: stroke 0.5s;
        }
    }

	.mail_link {
		line-height: 1;
		color: white;
		height: 40px;
	}

    .bttn_share {
        position: relative;
        overflow: hidden;
        transition: background-color 500ms;
        backface-visibility: hidden;
    }

    .social_icons {
        position: absolute;
        top: 100px;
        color: white;
        opacity: 0;
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: space-around;
        transition: opacity 500ms;
		z-index: 1;

        .fa {
            position: relative;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            font-size: 16px;
            transition: opacity 500ms;

            &:before {
                position: absolute;
                top: 50%;
                left: calc(50% + 1px);
                transform: translate(-50%, -50%);
            }
        }

        .link_icon {
            position: relative;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            transition: opacity 500ms;
            img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }

	#card_mobile {
        display: none;
        height: 100%;
		opacity: 0;
        padding: 35px;
        padding-top: 50px;
        box-sizing: border-box;
        color: white;
        text-align: center;

        &.facebook {
            height: calc(100% - 30px);
            .card_buttons {
                bottom: 90px;
            }

            .card_icon {
                bottom: 45px;
            }
        }

        .bttn_default {
            display: block;
        }

		.bttn_share {
            margin-right: 15px;
			&.active {
				background-color: white;
				color: white !important;
				.social_icons {
					top: 0;
					opacity: 1;

					.fa, .link_icon {
                        width: 30px;
                        height: 30px;
					}

                    .mail_link {
                        height: 30px;
                    }
				}
			}
		}


        &.do {
            background-color: $red;

            .social_icons {

                .fa, .link_icon {
                    background-color: $red;

                    &.active {
                        opacity: 0.5;
                    }
                }
            }

			.bttn_default:active {
				background-color: white;
				color: $red;
			}
        }

        &.listen {
            background-color: $orange;

            .social_icons {

                .fa, .link_icon {
                    background-color: $orange;

                    &.active {
                        opacity: 0.5;
                    }
                }
            }

			.bttn_default:active {
				background-color: white;
				color: $orange;
			}
        }
        &.make {
            background-color: $yellow;

            .social_icons {

                .fa, .link_icon {
                    background-color: $yellow;

                    &.active {
                        opacity: 0.5;
                    }
                }
            }

			.bttn_default:active {
				background-color: white;
				color: $yellow;
			}
        }
        &.buy {
            background-color: $pink;

            .social_icons {

                .fa, .link_icon {
                    background-color: $pink;

                    &.active {
                        opacity: 0.5;
                    }
                }
            }

			.bttn_default:active {
				background-color: white;
				color: $pink;
			}
        }
        &.watch {
            background-color: $peach;

            .social_icons {

                .fa, .link_icon {
                    background-color: $peach;

                    &.active {
                        opacity: 0.5;
                    }
                }
            }

			.bttn_default:active {
				background-color: white;
				color: $peach;
			}
        }
	}

    .mobile_card_sponsored {
        text-transform: uppercase;
        font-size: 12px;
        line-height: 15px;
        margin-top: 20px;

        &.disclaimer {
            margin: 0;
            font-size: 10px;
            line-height: 16px;
            opacity: 0.5;
        }
    }

    .card_mobile_image {
        width: 150px;
        height: 150px;
        margin: 15px auto;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    }

    .card_mobile_description {
        font-size: 16px;
        line-height: 25px;
        margin-top: 15px;
    }

    #clipboard_message {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: rgba(0, 0, 0, 0.4);
        border-radius: 5px;
        z-index: 1;
        padding: 50px;
        color: white;
        opacity: 0;
    }

    @media (max-width: $small-break) {
        .card_open {
            display: none !important;
        }

        .card_open_container {
            position: fixed;
            top: 0;
            left: 0;
            height: 100%;
            overflow-y: auto;
            z-index: 1;

            &.do {
                background-color: $red;
            }

            &.listen {
                background-color: $orange;
            }
            &.make {
                background-color: $yellow;
            }
            &.buy {
                background-color: $pink;
            }
            &.watch {
                background-color: $peach;
            }
        }

        #card_mobile {
            display: block;
        }

        .card_close {
            width: 20px;
            top: 15px;
            right: 15px;
        }

        .card_buttons {
            position: absolute;
            bottom: 60px;
            left: 30px;
            width: calc(100% - 60px);
        }

        .card_icon {
            bottom: 15px;
        }

        #clipboard_message {
            width: 80%;
            box-sizing: border-box;
            background-color: rgba(0,0,0,0.75);
            padding: 30px;
        }
    }

</style>



// WEBPACK FOOTER //
// card-open.vue?7d3bde4a